import { mediaHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';

export const LightBoxContentWrapper = styled.div`
  margin: 0 auto;
  width: 80%;
  ${mediaHelper('tabletMax')} {
    width: 100%;
  }
`;
